import React from "react";
import PropTypes from "prop-types";
import Book from "./index";
import { connect } from "react-redux";
import { Attachment, ICircle, Search } from "@vitalsource/vstui-icons";
import { t, ts } from "../../../core/translate";
import { selectors as booksSelectors } from "../../../../redux/books";
import { selectors as feenySelectors } from "../../../../redux/feeny";
import { selectors as ancillarySelectors } from "../../../../redux/ancillaries";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { actions as uiLibraryActions } from "../../../../redux/ui/library";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import { actions as bookActions } from "../../../../redux/book";
import { actions as bridgeActions } from "../../../../redux/bridge";
import CoursewareIcon from "../../library/icons/courseware/overlay";
import { expirationMessage } from "../expiration-message";
import LibraryHelpers from "../../../../stores/library-helpers";

const LicensedBook = ({
  licensedBook,
  bridgeBook,
  launchBook,
  returnBook,
  ancillarySummary,
  brand,
  openBookPanel,
  openSearchPanel,
  accessCode,
  underline,
  ...props
}) => {
  const book = { ...licensedBook, ...bridgeBook };
  const primary = [];
  if (
    accessCode &&
    accessCode.accessCode &&
    accessCode.href &&
    accessCode.revealed &&
    ancillarySummary.accessCodeCount
  ) {
    primary.push({
      onClick: () => {
        Fraction.Helpers.Locations.safeRedirect(accessCode.href, "_blank");
      },
      label: t("eresources.launch-courseware", "Launch Courseware")
    });
  } else if (accessCode && !accessCode.revealed && !book.ssoOnly) {
    primary.push({
      onClick: () => openBookPanel("courseware", book.title),
      label: t("library.reveal-code", "Reveal Access Code")
    });
  }
  primary.push({
    onClick: () => launchBook("launch-button"),
    label: t("library.open-book", "Open Book"),
    href: `#/books/${book.isbn}/`,
    ariaLabel: `${t("library.open-book", "Open Book")} - ${book.title}`
  });
  if (book && book.returnable) {
    primary.push({
      onClick: () => {
        returnBook();
        LibraryHelpers.returnBookToast(licensedBook.title, licensedBook.isbn);
      },
      label: t("library.return-book", "Return")
    });
  }

  const secondaryButtons = [];
  secondaryButtons.push({
    onClick: () => openBookPanel("details", book.title),
    label: t("library.details-icon", "View details", { bookTitle: book.title }),
    icon: ICircle
  });
  if (ancillarySummary.ancillariesCount) {
    secondaryButtons.push({
      onClick: () => openBookPanel("resources", book.title),
      label: t("filter.resources", "Resources"),
      icon: Attachment
    });
  }

  if (brand.Search.enabled) {
    secondaryButtons.push({
      onClick: () => openSearchPanel(book.title),
      label: t("base.search", "Search"),
      icon: Search
    });
  }

  const badges = [];
  const ancillaries = ancillarySummary.accessCodeCount;
  return (
    <Book
      {...props}
      underline={underline}
      extraOverlay={accessCode}
      overlayIcon={<CoursewareIcon />}
      ancillaries={ancillaries}
      title={book.title}
      coverURL={book.coverURL}
      isbn={book.isbn}
      primary={primary}
      secondary={secondaryButtons}
      onClick={() => launchBook("click-cover")}
      badges={badges}
      durationMessage={expirationMessage(book)}
    />
  );
};

const mapStateToProps = (state, props) => ({
  licensedBook: booksSelectors.getBookByIsbn(state, props.isbn),
  bridgeBook: bridgeSelectors.getAsset(state, props.isbn),
  ancillarySummary: ancillarySelectors.getAncillarySummaryForVbid(
    state,
    props.isbn
  ),
  brand: brandSelectors.getBrand(state),
  accessCode: ancillarySelectors.getAccessCodesForVbid(state, props.isbn)
});

const mapDispatchToProps = (dispatch, props) => ({
  openBookPanel: (tab, title) =>
    dispatch(uiLibraryActions.openBookPanel(props.isbn, tab, title)),
  openSearchPanel: title =>
    dispatch(uiLibraryActions.openSearchPanel(props.isbn, title)),
  launchBook: additionalContext =>
    dispatch(
      bookActions.launchLicensedBook(props.isbn, {
        context: `${props.context}-${additionalContext}`,
        bookIndex: props.index
      })
    ),
  returnBook: () => dispatch(bridgeActions.returnAsset(props.isbn))
});

LicensedBook.propTypes = {
  isbn: PropTypes.string.isRequired,
  context: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(LicensedBook);
